import { useMutation, useQueryClient } from '@tanstack/react-query';

import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';
import { RebalancingSchedule } from '@cast/types';

import { getRebalancingSchedulesQueryKey } from 'hooks/queries/scheduled-rebalancing/useRebalancingSchedulesQuery';

type UseUpdateScheduleMutationProps = {
  onSuccess?: (savedSchedule: RebalancingSchedule) => void;
  onError?: (error: unknown) => void;
};

export const useUpdateScheduleMutation = ({
  onSuccess,
  onError = () =>
    notify.error('Failed to update schedule', {
      key: 'failed-to-update-schedule',
    }),
}: UseUpdateScheduleMutationProps = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (config: RebalancingSchedule) => {
      return apiClient.scheduledRebalancing.updateSchedule({
        schedule: config,
        id: config.id,
      });
    },
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries({
        queryKey: getRebalancingSchedulesQueryKey(),
      });
      onSuccess?.(data);
    },
    onError,
  });
};
